export const ConfigServer = ({
    // serverUrl: "http://localhost:5000"
    serverUrl: window.location.origin
    //se agrega este al git ignore
    //este archivo no se debe de integrar
});